import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

const sidexApiUrls = Object.values(environment.apiUrls);

export const sidexApiAuthInterceptor: HttpInterceptorFn = (request, next) => {
    if (!isSidexApiRequest(request.url) || request.headers.has('Authorization')) {
        return next(request);
    }

    const oidcSecurityService = inject(OidcSecurityService);

    return oidcSecurityService.getAccessToken().pipe(
        switchMap((token) => {
            if (!token) {
                return throwError(() => new Error(`No access token available for SIDeX API request to ${request.url}`));
            }

            return next(
                request.clone({
                    setHeaders: {
                        Authorization: `Bearer ${token}`
                    }
                })
            );
        })
    );
};

function isSidexApiRequest(requestUrl: string): boolean {
    return sidexApiUrls.some(
        (apiUrl) => requestUrl === apiUrl || requestUrl.startsWith(`${apiUrl}/`) || requestUrl.startsWith(`${apiUrl}?`)
    );
}
